module.exports = __webpack_public_path__ + "img/link.2ca94b04.svg";